// Strategic alliances announced by the client. Copy is the client's wording
// (28 Sep 2026); the organization's own branding reads "Pro Football Retired
// Players Association".

import type { ImageName } from '@/generated/images'

export interface Alliance {
  id: string
  name: string
  logo: ImageName
  url: string
  description: string
}

export const alliances: Alliance[] = [
  {
    id: 'pfrpa',
    name: 'Pro Football Retired Players Association',
    logo: 'pfrpa-logo',
    url: 'https://www.pfrpa.com/',
    description:
      'Professional Retired Football Players Association and GIA Longevity U.S. will work together to develop meaningful health and educational opportunities.',
  },
]
